import React from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import { SPACING } from '../../../theme';
import {
  PreviewHeader,
  ButtonsShowcase,
  AlertsShowcase,
  FormElementsShowcase,
  ChipsBadgesShowcase,
  TableShowcase,
  CardsShowcase,
  AccordionShowcase,
  TypographyShowcase,
} from './InlineThemePreviewComponents';

/**
 * InlineThemePreview Component
 *
 * Shows a live preview of how themes will look when applied.
 * Displays inline within the page instead of as an overlay.
 */
const InlineThemePreview = ({ theme }) => {
  if (!theme) {
    return (
      <Paper
        sx={{ p: SPACING.xxl, border: '1px solid', borderColor: 'divider' }}
      >
        <Typography color="textSecondary">
          No theme selected for preview.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{
        p: SPACING.xxl,
        border: '1px solid',
        borderColor: 'divider',
        maxHeight: '80vh',
        overflow: 'auto',
        backgroundColor: theme.background_color,
      }}
    >
      <PreviewHeader theme={theme} />

      <Grid container spacing={3}>
        <ButtonsShowcase theme={theme} />
        <AlertsShowcase theme={theme} />
        <FormElementsShowcase theme={theme} />
        <ChipsBadgesShowcase theme={theme} />
        <TableShowcase theme={theme} />
        <CardsShowcase theme={theme} />
        <AccordionShowcase theme={theme} />
        <TypographyShowcase theme={theme} />
      </Grid>
    </Paper>
  );
};

export default InlineThemePreview;
